export const DSButtonV2Name = 'DSButtonv2';

export const DSButtonV2DataTestId = {
  ROOT: 'ds-button-v2',
};
export const DSButtonV2Slots = {
  ROOT: 'root',
};
